import React, { useState } from 'react';
import { useUISettings } from '../../context/UISettingsContext';
import { Button } from '../common/Button';

export function ShowTokenModal() {
  const { isShowTokenModalOpen, setIsShowTokenModalOpen, newSessionToken, showNotification } = useUISettings();
  const [copied, setCopied] = useState(false);

  if (!isShowTokenModalOpen) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(newSessionToken);
    setCopied(true);
    showNotification('Token copied to clipboard!', 'success');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 text-gray-800">Next Session Token</h3>
        
        <p className="text-sm text-gray-600 mb-4">
          Use this token for your next login. It changes each time you log in.
        </p>
        
        <div className="mb-6">
          <div className="flex">
            <input
              type="text"
              readOnly
              value={newSessionToken}
              className="flex-1 p-3 bg-gray-100 border border-gray-300 rounded-l-lg font-mono text-sm"
            />
            <button
              onClick={handleCopy}
              className={`px-4 py-2 rounded-r-lg transition ${
                copied ? 'bg-green-500' : 'bg-blue-500 hover:bg-blue-600'
              } text-white`}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>
        
        <Button
          onClick={() => setIsShowTokenModalOpen(false)}
          variant="secondary"
          fullWidth
        >
          Close
        </Button>
      </div>
    </div>
  );
}